import { jsonToHtml } from '@contentstack/json-rte-serializer';
import { parse as parseHTML } from 'node-html-parser';
import { Maybe, SysAssetConnection } from '../types/contentstack';

export function getAssetUrl(
  connection?: Maybe<SysAssetConnection> | undefined
) {
  return connection?.edges?.[0]?.node?.url || '';
}

// Renders a Contentstack rich-text field to HTML (or plain text); returns '' when the field is empty.
export function renderRichText(json: any, plainText?: boolean) {
  const doc = json?.json || json;

  if (!doc) {
    return '';
  }

  const html = jsonToHtml(doc);

  if (!plainText) {
    return html;
  }

  return parseHTML(html)?.textContent;
}
